// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PWj3","question":"styles_question__1xHJB","inputVisibleButton":"styles_inputVisibleButton__19Lj6","note":"styles_note__FqL3n"};